import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, MapPin } from 'lucide-react';
const PURCHASES = [{
  name: 'Martín',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Camila',
  location: 'Ciudad de México, México'
}, {
  name: 'Sebastián',
  location: 'Bogotá, Colombia'
}, {
  name: 'Florencia',
  location: 'Santiago, Chile'
}, {
  name: 'Andrés',
  location: 'Madrid, España'
}, {
  name: 'Paula',
  location: 'Lima, Perú'
}, {
  name: 'Joaquín',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Daniela',
  location: 'Quito, Ecuador'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 3000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showPopup = () => {
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (random delay between 8-15 seconds)
      const nextDelay = Math.floor(Math.random() * 7000) + 8000;
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        showPopup();
      }, nextDelay);
    }, 5000);
  };
  const currentPurchase = PURCHASES[currentIndex];
  return <AnimatePresence data-id="element-211">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full bg-white rounded-lg shadow-2xl border-l-4 border-green-500 p-4 flex items-center gap-3" data-id="element-212">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-213">
            <BookOpen className="w-5 h-5 text-green-600" data-id="element-214" />
          </div>
          <div className="flex-1" data-id="element-215">
            <p className="text-sm font-bold text-gray-900" data-id="element-216">
              🔥 {currentPurchase.name} compró el libro
            </p>
            <div className="flex items-center text-xs text-gray-500 mt-0.5" data-id="element-217">
              <MapPin className="w-3 h-3 mr-1" data-id="element-218" />
              {currentPurchase.location}
            </div>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-219">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}